// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { Pressable, StyleSheet, View } from 'react-native';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { Text } from '@/components/Themed';
import { useI18n } from '@/i18n';

export default function TourEditScreen() {
  const router = useRouter();
  const { tourId } = useLocalSearchParams<{ tourId?: string }>();
  const { t } = useI18n();

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{t('tourEdit.title')}</Text>
      <Text style={styles.subtitle}>{t('tourEdit.webOnlyNote')}</Text>
      <Text style={styles.tourId}>{tourId ?? t('tourEdit.tourIdMissing')}</Text>
      <Pressable style={styles.backButton} onPress={() => router.push('/tournaments')}>
        <Text style={styles.backText}>{t('tourEdit.backToTours')}</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    backgroundColor: '#0c1328',
    padding: 24,
  },
  title: {
    color: '#f8fafc',
    fontSize: 22,
    fontWeight: '800',
  },
  subtitle: {
    color: '#9fb3ff',
    textAlign: 'center',
  },
  tourId: {
    color: '#e2e8f0',
    fontWeight: '600',
  },
  backButton: {
    marginTop: 8,
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: 'rgba(125,178,255,0.45)',
    backgroundColor: 'rgba(125,178,255,0.12)',
  },
  backText: {
    color: '#cfe3ff',
    fontWeight: '700',
    fontSize: 12,
  },
});
